import { useState, useEffect } from 'react';
import { getMandatById } from '@app/api/data/mandats';

export const usePubliciteFromMandat = (mandatId: number | null | undefined) => {
    const [publiciteOptions, setPubliciteOptions] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!mandatId) {
            setPubliciteOptions([]);
            return;
        }

        const fetchPublicites = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getMandatById(mandatId.toString());
                const mandat = response?.data;

                if (mandat?.listePublicites) {
                    const options = mandat.listePublicites
                        .split(';')
                        .map((item: string) => item.trim())
                        .filter((item: string) => item.length > 0);
                    setPubliciteOptions(options);
                } else {
                    setPubliciteOptions([]);
                }
            } catch (err: any) {
                console.error('Error fetching mandat publicites:', err);
                setError(err?.message || 'Erreur lors du chargement');
                setPubliciteOptions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPublicites();
    }, [mandatId]);

    return { publiciteOptions, loading, error };
};
